export const seoPages = {
  "creation-site-vitrine": {
    slug: "creation-site-vitrine",
    title: "Creation de site vitrine professionnel",
    metaTitle: "Creation de site vitrine professionnel en France | Fold Web Agency",
    metaDescription:
      "Creation de sites vitrines modernes, rapides et responsives pour independants, TPE, PME, cabinets et prestataires de services partout en France.",
    eyebrow: "Site vitrine",
    heroTitle: "Creation de site vitrine professionnel pour gagner en credibilite",
    intro:
      "Fold Web Agency cree des sites vitrines professionnels pour presenter votre activite, rassurer vos prospects et transformer les visites en prises de contact. Chaque page est pensee pour etre claire, rapide, lisible sur mobile et comprehensible par Google.",
    bullets: [
      "Arborescence claire pour presenter votre entreprise, vos services et vos preuves de confiance",
      "Design responsive adapte au mobile, a la tablette et a l'ordinateur",
      "Formulaire de contact, boutons d'action et parcours de conversion visibles",
      "Balises title, meta description, titres Hn, maillage interne et base SEO propre",
    ],
    sections: [
      {
        title: "Pour quels professionnels ?",
        body:
          "Un site vitrine est ideal pour une entreprise de service, un independant, un cabinet, un commerce, une association ou une PME qui veut presenter son activite de maniere professionnelle. Nous construisons des pages utiles pour les visiteurs : services, realisations, avis, presentation, contact et informations essentielles.",
      },
      {
        title: "Une structure orientee conversion",
        body:
          "Nous construisons chaque page autour d'un objectif simple : comprendre vite, rassurer, puis contacter. L'arborescence, les textes, les visuels et les boutons sont penses pour accompagner un visiteur qui decouvre votre entreprise et l'aider a passer a l'action sans friction.",
      },
      {
        title: "Une base SEO des la mise en ligne",
        body:
          "La creation du site integre les fondamentaux du referencement naturel : URL propres, balises coherentes, contenus structures, sitemap, responsive design et temps de chargement maitrise. L'objectif est de donner a Google des signaux clairs des le lancement.",
      },
    ],
    faq: [
      {
        question: "Combien de pages faut-il pour un site vitrine ?",
        answer:
          "La plupart des projets commencent avec 4 a 8 pages : accueil, services, realisations, a propos, contact et pages legales.",
      },
      {
        question: "Le site sera-t-il visible sur mobile ?",
        answer:
          "Oui, le responsive est integre des le depart pour offrir une experience confortable sur mobile, tablette et ordinateur.",
      },
      {
        question: "Le site vitrine peut-il evoluer plus tard ?",
        answer:
          "Oui. Le site peut commencer simplement puis evoluer avec de nouvelles pages, des contenus SEO, un espace client, des formulaires avances ou des integrations selon vos besoins.",
      },
    ],
  },
  "creation-site-wordpress": {
    slug: "creation-site-wordpress",
    title: "Creation de site WordPress",
    metaTitle: "Creation de site WordPress professionnel | Fold Web Agency",
    metaDescription:
      "Creation de sites WordPress professionnels, performants, securises et faciles a administrer pour entreprises, independants et PME en France.",
    eyebrow: "WordPress",
    heroTitle: "Creation de site WordPress propre, evolutif et simple a gerer",
    intro:
      "Nous creons des sites WordPress adaptes aux besoins des professionnels : presentation de services, acquisition de contacts, gestion simple des contenus et base technique durable. L'objectif est d'avoir un site administrable sans sacrifier la performance ni la clarte.",
    bullets: [
      "Installation et configuration WordPress",
      "Theme adapte a votre identite visuelle et a vos objectifs commerciaux",
      "Pages administrables, contenus structures et blocs faciles a modifier",
      "Optimisation performance, securite, sauvegardes et SEO de base",
    ],
    sections: [
      {
        title: "WordPress sans lourdeur inutile",
        body:
          "WordPress est puissant lorsqu'il est bien cadre. Nous evitons les empilements de plugins inutiles et nous gardons une structure maintenable, pour un site plus stable et plus facile a faire evoluer.",
      },
      {
        title: "Autonomie apres livraison",
        body:
          "L'objectif est que vous puissiez modifier les contenus essentiels sans dependance permanente. Nous pouvons aussi assurer la maintenance si vous preferez nous confier la partie technique.",
      },
      {
        title: "Un WordPress pense pour durer",
        body:
          "Nous preparons le site avec une logique de croissance : pages services, blog, formulaires, suivi statistique, redirections et optimisations SEO peuvent etre ajoutes progressivement sans repartir de zero.",
      },
    ],
    faq: [
      {
        question: "Puis-je modifier mon site WordPress moi-meme ?",
        answer:
          "Oui. Les contenus principaux peuvent etre rendus administrables pour que vous puissiez mettre a jour textes, images et pages.",
      },
      {
        question: "WordPress est-il adapte au SEO ?",
        answer:
          "Oui, a condition d'avoir une structure propre, des pages rapides, des titres coherents et des contenus utiles.",
      },
      {
        question: "Pouvez-vous optimiser un WordPress deja en ligne ?",
        answer:
          "Oui. Nous pouvons auditer un site WordPress existant, corriger les points bloquants et ameliorer la structure, les performances, la securite et les contenus.",
      },
    ],
  },
  "maintenance-wordpress": {
    slug: "maintenance-wordpress",
    title: "Maintenance WordPress",
    metaTitle: "Maintenance WordPress et securite | Fold Web Agency",
    metaDescription:
      "Maintenance WordPress pour garder votre site a jour, securise, sauvegarde, fonctionnel et performant dans la duree.",
    eyebrow: "Maintenance",
    heroTitle: "Maintenance WordPress pour garder un site fiable, rapide et securise",
    intro:
      "La maintenance WordPress permet de limiter les bugs, les failles de securite, les ralentissements et les interruptions. Nous assurons le suivi technique pour que votre site reste stable et disponible pour vos visiteurs.",
    bullets: [
      "Mises a jour WordPress, themes et extensions",
      "Sauvegardes, controles apres mise a jour et verification du bon fonctionnement",
      "Surveillance des formulaires et elements critiques",
      "Interventions correctives, conseils techniques et suivi des alertes",
    ],
    sections: [
      {
        title: "Pourquoi maintenir un site ?",
        body:
          "Un site WordPress evolue avec son environnement : versions PHP, plugins, navigateurs, securite. Sans suivi, de petites alertes peuvent devenir des blocages visibles pour vos clients.",
      },
      {
        title: "Un suivi adapte a votre activite",
        body:
          "Nous pouvons intervenir ponctuellement ou mettre en place un suivi regulier. L'objectif est de proteger le site sans complexifier votre quotidien.",
      },
      {
        title: "Moins de risques pour votre visibilite",
        body:
          "Un site indisponible, pirate ou lent peut nuire a l'experience utilisateur et au referencement. La maintenance aide a conserver une base saine pour vos prospects, vos formulaires et votre visibilite Google.",
      },
    ],
    faq: [
      {
        question: "La maintenance est-elle obligatoire ?",
        answer:
          "Elle n'est pas obligatoire, mais elle est fortement recommandee pour eviter les failles, les incompatibilites et les pertes de donnees.",
      },
      {
        question: "Pouvez-vous reprendre un site existant ?",
        answer:
          "Oui, apres un audit rapide de l'installation, des extensions et de l'hebergement.",
      },
      {
        question: "Que se passe-t-il en cas de bug ?",
        answer:
          "Nous analysons l'origine du probleme, securisons les elements critiques et proposons une correction adaptee selon l'urgence et le niveau de maintenance prevu.",
      },
    ],
  },
  "referencement-seo": {
    slug: "referencement-seo",
    title: "Referencement SEO",
    metaTitle: "Referencement SEO pour site professionnel | Fold Web Agency",
    metaDescription:
      "Optimisation SEO pour ameliorer la comprehension de votre site par Google, renforcer votre visibilite et attirer un trafic qualifie en France.",
    eyebrow: "SEO",
    heroTitle: "Referencement SEO pour etre mieux compris par Google",
    intro:
      "Nous travaillons le SEO comme un levier de visibilite durable : technique propre, contenus utiles, structure lisible et signaux de confiance. L'objectif est d'aider vos pages a repondre clairement aux recherches de vos prospects.",
    bullets: [
      "Audit technique et corrections prioritaires",
      "Optimisation des titres, metas et contenus",
      "Structure de pages par intention de recherche",
      "Maillage interne et recommandations de notoriété",
    ],
    sections: [
      {
        title: "Un SEO centre sur l'intention",
        body:
          "Une page performe mieux quand elle repond a une question precise. Nous construisons les contenus autour des recherches reelles de vos prospects, sans bourrage de mots-cles.",
      },
      {
        title: "Technique et contenu ensemble",
        body:
          "Le SEO ne se resume pas aux balises. Il faut aussi des pages rapides, accessibles, bien reliees entre elles et suffisamment utiles pour meriter des liens et des contacts.",
      },
      {
        title: "Une progression nationale, sans ciblage local force",
        body:
          "Nous pouvons travailler une visibilite sur toute la France avec des pages de services claires, des contenus de fond, des cas clients et un maillage interne coherent. L'objectif n'est pas de multiplier des pages geographiques faibles, mais de construire une autorite utile.",
      },
    ],
    faq: [
      {
        question: "Combien de temps faut-il pour voir des resultats SEO ?",
        answer:
          "Les premiers signaux peuvent apparaitre en quelques semaines, mais une progression durable se mesure plutot sur plusieurs mois.",
      },
      {
        question: "Le SEO remplace-t-il la publicite ?",
        answer:
          "Non. Le SEO construit une visibilite durable, tandis que la publicite peut generer du trafic plus rapidement. Les deux peuvent se completer.",
      },
      {
        question: "Faut-il creer beaucoup de pages pour progresser ?",
        answer:
          "Pas forcement. Il vaut mieux creer moins de pages mais plus utiles, avec une intention claire, un contenu complet, des liens internes et des preuves de confiance.",
      },
    ],
  },
};

export const seoPageList = Object.values(seoPages);
